export const _test_question_languages = [
    {code : "AF", label: "Afrikaans"},
    {code : "AM", label: "Amharic"},
    {code : "AR", label: "Arabic"},
    {code : "AR-AE", label: "Arabic (U.A.E.)"},
    {code : "AR-BH", label: "Arabic (Bahrain)"},
    {code : "AR-DZ", label: "Arabic (Algeria)"},
    {code : "AR-EG", label: "Arabic (Egypt)"},
    {code : "AR-OM", label: "Arabic (Oman)"},
    {code : "AR-SA", label: "Arabic (Saudi Arabia)"},
    {code : "AZ-LTN", label: "Azerbaijani (Latin)"},
    {code : "BE", label: "Belarusian"},
    {code : "BG", label: "Bulgarian"},
    {code : "BN", label: "Bengali"},
    {code : "BN-BD", label: "Bengali (Bangladesh)"},
    {code : "BN-IN", label: "Bengali (India)"},
    {code : "BR", label: "Breton"},
    {code : "BS", label: "Bosnian"},
    {code : "BU", label: "Burmese"},
    {code : "BU-za", label: "Burmese Zawgyi"},
    {code : "CA-ES", label: "Catalan"},
    {code : "CY", label: "Welsh"},
    {code : "CZ", label: "Czech"},
    {code : "DE", label: "German"},
    {code : "DE-AT", label: "German (Austria)"},
    {code : "DE-CH", label: "German (Switzerland)"},
    {code : "DK", label: "Danish"},
    {code : "DV", label: "Divehi"},
    {code : "EN", label: "English"},
    {code : "EN-AU", label: "English (Australia)"},
    {code : "EN-CA", label: "English (Canada)"},
    {code : "EN-GB", label: "English (United Kingdom)"},
    {code : "EN-IN", label: "English (India)"},
    {code : "EN-ML", label: "Malayalam"},
    {code : "EN-US", label: "English (United States)"},
    {code : "EN-US-AA", label: "American English African"},
    {code : "EN-US-AL", label: "American English"},
    {code : "EN-US-CA", label: "American English Chinese"},
    {code : "EN-US-DS", label: "American English - Deep South"},
    {code : "EN-US-HA", label: "American English - Hyspanic"},
    {code : "EN-US-IS", label: "American English - Inland South"},
    {code : "EN-US-MA", label: "American English - Mid-Atlantic"},
    {code : "EN-US-NE", label: "American English - New England"},
    {code : "EN-ZA", label: "English (South Africa)"},
    {code : "ES", label: "Spanish"},
    {code : "ES-419", label: "Spanish (Latin America)"},
    {code : "ES-AR", label: "Spanish (Argentina)"},
    {code : "ES-ES", label: "Spanish (Spain)"},
    {code : "ES-MX", label: "Spanish (Mexico)"},
    {code : "ES-US", label: "Spanish (USA)"},
    {code : "ES-CL", label: "Spanish (Chile)"},
    {code : "ET", label: "Estonian"},
    {code : "EU", label: "Basque"},
    {code : "FA", label: "Farsi"},
    {code : "FA-IR", label: "Farsi (Iran)"},
    {code : "FI", label: "Finnish (Finland)"},
    {code : "FIL", label: "Filipino"},
    {code : "FL-PH", label: "Filipino (Philippines)"},
    {code : "FR", label: "French"},
    {code : "FR-BE", label: "French (Belgium)"},
    {code : "FR-CA", label: "French (Canada)"},
    {code : "FR-CH", label: "French (Switzerland)"},
    {code : "FR-FR", label: "French (France)"},
    {code : "GA", label: "Irish"},
    {code : "GD", label: "Gaelic (Scotland)"},
    {code : "GL", label: "Galician"},
    {code : "GR", label: "Greek(Greece)"},
    {code : "GU", label: "Gujarati"},
    {code : "HA", label: "Hausa"},
    {code : "HE", label: "Hebrew(Israel)"},
    {code : "HI", label: "Hindi"},
    {code : "hi-HI", label: "Hinglish"},
    {code : "HR", label: "Croatian(Croatia)"},
    {code : "HT", label: "Haitian Creole"},
    {code : "HU", label: "Hungarian(Hungary)"},
    {code : "HY", label: "Armenian"},
    {code : "ID", label: "Indonesian"},
    {code : "IS", label: "Icelandic"},
    {code : "IT-CH", label: "Italian (Switzerland)"},
    {code : "IT-IT", label: "Italian (Italy)"},
    {code : "JA", label: "Japanese"},
    {code : "JV", label: "Javanese"},
    {code : "KA", label: "Georgian"},
    {code : "KK-KZ", label: "Kazakh"},
    {code : "KM", label: "Khmer (Cambodian)"},
    {code : "KN", label: "Kannada"},
    {code : "KR", label: "Korean"},
    {code : "KU", label: "Kurdish"},
    {code : "LB", label: "Luxembourgish"},
    {code : "LO", label: "Lao (Laothian)"},
    {code : "LT", label: "Lithuanian"},
    {code : "LV", label: "Latvian"},
    {code : "MK", label: "Macedonian"},
    {code : "MO", label: "Moldavian"},
    {code : "MN", label: "Mongolian"},
    {code : "MS", label: "Malay"},
    {code : "NB", label: "Norwegian (Bokmaal)"},
    {code : "NE", label: "Nepali"},
    {code : "NL", label: "Dutch"},
    {code : "NL-BE", label: "Flemish"},
    {code : "NL-NL", label: "Dutch (Netherlands)"},
    {code : "NN", label: "Norwegian (Nynorsk)"},
    {code : "NO", label: "Norwegian"},
    {code : "PA", label: "Punjabi"},
    {code : "PK", label: "Urdu(Pakistan)"},
    {code : "PL", label: "Polish(Poland)"},
    {code : "PS", label: "Pashto"},
    {code : "PT", label: "Portuguese"},
    {code : "PT-BR", label: "Portuguese (Brazil)"},
    {code : "PT-PT", label: "Portuguese (Portugal)"},
    {code : "RO", label: "Romanian"},
    {code : "RU", label: "Russian"},
    {code : "SI", label: "Sinhalese"},
    {code : "SK", label: "Slovak(Slovakia)"},
    {code : "SL", label: "Slovenian"},
    {code : "SLA", label: "Montenegrin"},
    {code : "SO", label: "Somali"},
    {code : "SQ", label: "Albanian"},
    {code : "SR", label: "Serbian(Serbia)"},
    {code : "SR-LA", label: "Serbian (Latin)"},
    {code : "SV", label: "Swedish"},
    {code : "SV-SE", label: "Swedish (Sweden)"},
    {code : "SW", label: "Swahili"},
    {code : "TA", label: "Tamil"},
    {code : "TE", label: "Telugu"},
    {code : "TH", label: "Thai"},
    {code : "TL", label: "Tagalog"},
    {code : "TR", label: "Turkish"},
    {code : "TT", label: "Tatar"},
    {code : "TW", label: "Twi"},
    {code : "UK", label: "Ukrainian"},
    {code : "UZ", label: "Uzbek"},
    {code : "VI", label: "Vietnamese"},
    {code : "YI", label: "Yiddish"},
    {code : "ZH-CN", label: "Chinese (Simplified)"},
    {code : "ZH-HK", label: "Chinese (Traditional Hong Kong)"},
    {code : "ZH-SG", label: "Chinese (Simplified Singapore)"},
    {code : "ZH-TW", label: "Chinese ( Traditional Taiwan)"},
    {code : "ZH-YU", label: "Chinese (Cantonese)"},
    {code : "ZU", label: "Zulu"}
]

export const test_question_languages =  _test_question_languages.sort((a,b) => a.label.localeCompare(b.label));






















